import { useDisplay } from 'vuetify'
import { useOrganization } from '../organization/organization'
import { useBoxPolicy } from './box-policy'
import type { AdminBox } from '@deepcloud/api-deep-box'

export function useBoxAdmin(adminBox: Ref<AdminBox | undefined>) {
  const { canAdminAccess } = useBoxPolicy()

  const { xs } = useDisplay()

  const userCanAdminAccess = computed(
    () =>
      (adminBox.value && canAdminAccess(adminBox.value) && !xs.value) || false,
  )

  const { currentContextOrgId } = useOrganization()

  const adminOrAccessOrgId = computed(() =>
    adminBox.value && userCanAdminAccess.value
      ? adminBox.value.companyId
      : currentContextOrgId.value,
  )

  return {
    userCanAdminAccess,
    adminOrAccessOrgId,
  }
}
